import React from 'react';
import { useTranslation } from '@shared/core';
import { Box, TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const SponsoredTag = () => {
  const { tq } = useTranslation('accommodationsConsole');

  return (
    <Box
      position="absolute"
      bottom={pxToRem(8)}
      left={pxToRem(8)}
      paddingX={pxToRem(6)}
      paddingY={pxToRem(2)}
      borderRadius={pxToRem(4)}
      backgroundColor="mono14"
    >
      <TextV2
        typographyVariant="label2"
        color="white"
      >
        {tq`Ad`}
      </TextV2>
    </Box>
  );
};
